<template>
  <div class="check-list">
    <search
      :formModel="formModel"
      :rules="rules"
      :formButton="formButton"
      :deviceModelBusiType="10"
      :mulTime="mulTime"
    ></search>
    <m-table
      i18n-path="query"
      :loading="loading"
      :tableData="nuclideData"
      :tableColumn="tableColumn"
      :pagiOption="pagiOption"
      v-on:search="search"
    ></m-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { nuclideListServer, rm1000NuclideOrdataServer } from '@/api/query';
import { formatTimestamp, downFile, dayTime } from '@/utils/utils';
import ctt from '@/utils/const';
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';

export default {
  name: 'checkList',
  props: {
    sn: String
  },
  components: { Search, MTable },
  data() {
    return {
      hisData: [],
      nuclideData: [],
      loading: false,
      formModel: {
        sn: '',
        // linkType: this.sn ? 1 : 0,
        officeId: [],
        taskId: [],
        nuclideName: '',
        deviceModel: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      rules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'change' }]
      },
      mulTime: {
        mul: false,
        dateType: 'datetimerange'
      },
      tableColumn: [],
      formButton: [
        {
          text: '查询',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        },
        {
          text: '导出',
          code: '010721',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap']),
    comParams() {
      const { formModel, pagiOption } = this;
      return {
        beginTime: formModel.rangeDateVal && formModel.rangeDateVal[0],
        endTime: formModel.rangeDateVal && formModel.rangeDateVal[1],
        limit: pagiOption.limit,
        offset: pagiOption.offset,
        sn: formModel.sn,
        nuclideName: formModel.nuclideName
      };
    }
  },
  methods: {
    formatTimestamp,
    search() {
      const { deviceType } = this.deviceSNMap[this.comParams.sn];

      let apiDict = {
        [ctt.RM1000]: rm1000NuclideOrdataServer,
        [ctt.RG_05]: nuclideListServer
      };
      this.loading = true;
      apiDict[deviceType](this.comParams)
        .then(res => {
          this.tableColumn = (res.data.dimensions || []).map((e, i) => ({
            prop: e,
            label: res.data.dimensionsZh[i]
          }));

          this.nuclideData = res.data.pageData.list;
          this.pagiOption.total = res.data.pageData.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    hisExport(op) {
      op.loading = true;
      let obj = {
        sn: this.comParams.sn,
        beginTime: this.comParams.beginTime,
        endTime: this.comParams.endTime,
        nuclideName: this.comParams.nuclideName
      };
      downFile({
        url: '/stat/exportRg05NuclideOrdata',
        method: 'get',
        params: Object.assign(obj)
      }).finally(() => {
        op.loading = false;
      });
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.hisData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    }
  },
  watch: {
    sn: {
      handler(n, o) {
        if (n !== o) this.resetSearch();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.check-list {
  box-sizing: border-box;
}
</style>
